




























































import Vue from 'vue';
import Component from 'vue-class-component';
import giftcard from '@/store/modules/giftcard';
import cart from '@/store/modules/cart';
import handleMessage from '@/commons/messageManager';

@Component({
    components: {},
})
export default class GiftCard extends Vue {
    private get applied(): boolean {
        return giftcard.applied;
    }

    private set applied(value) {
        giftcard.setApplied(value);
    }

    private get loading(): boolean {
        return cart.loadingFlags.giftcard;
    }

    private set loading(value) {
        cart.flagLoading({ key: 'giftcard', value });
    }

    private get giftCardCode(): string {
        return giftcard.giftCard.code;
    }

    private set giftCardCode(code: string) {
        giftcard.setGiftCardCode(code);
    }

    private get getAmount(): any {
        return giftcard.giftCard.credit;
    }

    private get verified(): boolean {
        return giftcard.verified;
    }

    private set verified(value: boolean) {
        giftcard.setVerified(value);
    }

    private async getGiftCardCredit(giftCardCode: string) {
        this.loading = true;
        this.verified = false;

        const res = await giftcard.getGiftCardCredit(giftCardCode);

        if (!res.error) {
            this.verified = true;
        } else {
            this.verified = false;
            handleMessage('error', this.$t(res.error).toString());
        }

        this.loading = false;
    }

    private async applyGiftCard() {
        const valid = await this.$validator.validate('giftcardcode');

        if (!valid) {
            return;
        }

        let res: boolean = false;
        this.loading = true;

        // If not verified try to verify
        if (!this.verified) {
            await this.getGiftCardCredit(this.giftCardCode);
        }

        // If verify fails, show error
        if (this.verified) {
            res = await giftcard.applyGiftCard(giftcard.giftCard.credit);

            if (res) {
                handleMessage('success', this.$t('Gift card applied').toString());
            }
        }

        this.applied = res;
        this.loading = false;
    }

    private async removeGiftCard() {
        let res: boolean = false;
        this.loading = true;

        if (this.applied) {
            res = await giftcard.removeGiftCard();
        } else {
            handleMessage('error', this.$t('Please verify your gift card code first').toString());
        }

        if (!res) {
            this.giftCardCode = '';
        }

        this.verified = res;
        this.applied = res;
        this.loading = false;
    }
}
